import styled from "styled-components";
import { colors } from "../../../../utils";

export const Icon = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid;
  border-color: ${({ isActive }) => (isActive ? colors.purple : "transparent")};
  padding: 4px;
  border-radius: 4px;
`;


export const IconView = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  flex-wrap: wrap; 
  max-width: calc(100% - 60px);
`;

export const IconActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px; /* Space between action icons */
  /* Optionally set a fixed width if needed */
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start; /* Align items to the start */
  gap: 10px;
  width: 100%; /* Ensure the row takes the full width */
`;

export const NoLinksWrapper = styled.div`
  background-color: ${colors.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  border: 1px dashed ${colors.darkGrey};
  border-radius: 8px;
`;
